import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { useGetCalculators } from 'domains/Calculator/hooks'
import { useSubfilterActions } from 'hooks'
import { StyledDetails } from '../CustomerProfileFilter.styles'
import { useTranslations } from 'contexts/Translation'
import { Text } from '@qonsoll/react-design'

const CalculatorFilter = ({ filterData, setFilterData }) => {
  // [ADDITIONAL_HOOKS]
  const [calculators] = useGetCalculators()
  const { t } = useTranslations()

  // [COMPUTED_PROPERTIES]
  const summaryStyles = { marginBottom: '8px' }

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'calculator',
    operand: '=='
  })

  return (
    <StyledDetails
      open={localStorage.getItem(`calculator-details-visibility`) === 'opened'}>
      <summary
        style={summaryStyles}
        onClick={() => onToggleDetails('calculator')}>
        {t('Calculator')}
      </summary>
      {calculators?.map((calculator, index) => (
        <div key={`status-${index}`}>
          <Checkbox
            key={`status-${index}`}
            checked={checkIsEnabled(calculator)}
            onChange={() => onChange(calculator)}>
            <Text wordBreak="break-all">
              {calculator?.platforms || t('Unnamed filter')}
            </Text>
          </Checkbox>
        </div>
      ))}
    </StyledDetails>
  )
}

CalculatorFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default CalculatorFilter
